module.exports = __webpack_public_path__ + "static/media/logo.50ccd7eb.svg";